import React, { useEffect } from "react";
import { UpdateUserProfile } from "@hedgefund/shared";
import { useSelector, useDispatch } from "react-redux";
import {
  getInvestorType,
  getCurrentUserDetails,
  updateUserProfile,
  updateUserPassword,
} from "./actions";
import {
  getUserDetail,
  updateUserDetail,
  updateUserStatus,
  getRoles,
} from "../CreateNewUser/actions";

// import { useHistory } from "react-router-dom";
import { alertService } from "@hedgefund/shared/src/Alert/index";

const UpdateUser = ({ location }) => {
  const dispatch = useDispatch();
  const userDetailState = useSelector((state) => state.userDetails);
  const createUserState = useSelector((state) => state.createNewUsers);
  useEffect(() => {
    dispatch(getRoles());
  }, [dispatch]);
  // const history = useHistory();

  const { getCurrentUser, loading, userloader, passLoader } = userDetailState;
  const { userDetail } = createUserState;
  const splitId = location?.pathname?.split("/");
  const id = splitId[2];

  useEffect(() => {
    if (location.pathname === `/user/${id}`) {
      dispatch(getUserDetail(id));
    }
    if (location.pathname === "/user") {
      dispatch(getCurrentUserDetails());
    }
    dispatch(getInvestorType());
  }, [dispatch, id, location.pathname]);

  const onSuccess = () => {
    alertService.success("Updated Successfully", { autoClose: true });
    // setTimeout(() => {
    //   history.push("/management");
    // }, 1000);
  };

  // const onSuccessCurrentUser = () => {
  //   alertService.success("Updated Successfully", { autoClose: true });
  // };

  const onSubmit = (value) => {
    
    if (location.pathname === `/user/${id}`) {
      dispatch(updateUserDetail(value, onSuccess));
    }
    if (location.pathname === "/user") {
      dispatch(updateUserProfile(value, onSuccess));
    }
  };

  const onSubmitUserStatus = (value) => {
    dispatch(updateUserStatus(value, onSuccess));
  };

  const onSubmitPasswordChange = (values) => {
    dispatch(updateUserPassword(values, onSuccess));
  };

  return (
    <UpdateUserProfile
      resetPassword
      getCurrentUser={
        location.pathname === `/user/${id}` ? userDetail : getCurrentUser
      }
      userStatus={location.pathname === "/user" ? false : true}
      onSubmitDetails={onSubmit}
      loading={loading}
      onSubmitUserStatus={onSubmitUserStatus}
      createUserState={createUserState?.loading}
      userloader={userloader}
      id={id}
      roles={createUserState.roles}
      onSubmitPasswordChange={onSubmitPasswordChange}
      passLoader={passLoader}
      pathName={location?.pathname}
      selfUpdate={location.pathname === `/user/${id}`}
    />
  );
};

export default UpdateUser;
